<template>
  <div class="hello">
    <div class="topOperation">
      <div class="top-left">
        <div>
          <ShowNavHead />
        </div>
      </div>
      <div class="top-right">
        <el-input style="width:250px;margin-right: 20px;" type="text" placeholder="请输入报表名称查询" v-model="infoQuery.custname" clearable @keyup.enter.native="searchKeyWord"></el-input>
        <!-- <el-button type="text" @click="dropDownScreen">
          <img style="margin-right:20px" src="../../assets/employee/images/screen.png" />
        </el-button> -->
      </div>
    </div>
    <div class="main-con">
      <div class="crumbs">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item>报表</el-breadcrumb-item>
          <el-breadcrumb-item>利润报表</el-breadcrumb-item>
          <el-breadcrumb-item>导出记录</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="expRecordTable">
        <el-table :data="tableData" :max-height="tableHeight-180" style="width: 99%" v-loading="listLoading" element-loading-text="导出记录生成中" element-loading-spinner="el-icon-loading">
          <!-- <el-table-column align="center" type="selection" width="50"></el-table-column> -->
          <el-table-column align="center" label="序号" type="index" width="100"></el-table-column>
          <!-- <el-table-column align="center" label="服务中心" prop="StrServCentName" min-width="12%"></el-table-column> -->
          <!-- <el-table-column align="center" label="报表名称" prop="StrOutCustName" min-width="16%"></el-table-column> -->
          <el-table-column align="center" label="报表名称" prop="label" min-width="12%" fit :show-overflow-tooltip="true"></el-table-column>
          <!-- <el-table-column align="center" label="业务立项部门" prop="StrImpInstName" min-width="15%"></el-table-column> -->
          <!-- <el-table-column align="center" label="负责客服" prop="StrServUsrName" min-width="15%"></el-table-column> -->
          <el-table-column align="center" label="格式" prop="DtImpDate" min-width="16%">
            <template>xls</template>
          </el-table-column>
          <el-table-column align="center" label="操作人员" prop="Username" width="100px" fit :show-overflow-tooltip="true"></el-table-column>
          <el-table-column align="center" label="操作时间" min-width="16%">
            <template slot-scope="{row}">
              <span>{{row.DtImpDate.replace('T','  ')}}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="状态" prop="DtImpDate" min-width="16%">
            <template slot-scope="scope">
              <!-- {{(scope.row.path) ? "已生成" : "正在生成中"}} -->
              <span v-show="scope.row.path">已生成</span>
              <span v-show="!scope.row.path&&(new Date().getTime() < new Date((new Date(scope.row.DtImpDate)).valueOf() + 360000).getTime())">
                <i class="el-icon-loading"></i>
                <span>正在生成中</span>
              </span>
              <span v-show="!scope.row.path&&(new Date().getTime() > new Date((new Date(scope.row.DtImpDate)).valueOf() + 360000).getTime())">
                <span>导出失败</span>
              </span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="操作" prop="StrOperType" min-width="13%">
            <template slot-scope="scope">
              <a :href="scope.row.path" v-if="scope.row.path">下载</a>
            </template>
          </el-table-column>
        </el-table>
        <div class="block" v-if="totalnum>0">
          <el-pagination @current-change="handleCurrentChange" :current-page.sync="currentPage" :page-size="10" layout="total,prev, pager, next, jumper" :total="totalnum"></el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import xz from "../../common";
  export default {
    name: "HelloWorld",
    data() {
      return {
        tablePath: this.$store.state.EMP.tablePath,
        tableHeight: 0,
        listLoading: false,
        custname: "",
        qStstus: "",
        opType: "import",
        isActive: 0,
        list: [
          // {
          //   name: "导入记录",
          //   value: "import"
          // },
          {
            name: "导出记录",
            value: "export"
          }
        ],
        showPage: 0,
        select: "",
        ss: "",
        tableData: [],
        currentPage: 1,
        totalnum: 1,
        //下拉筛选
        showDropScreen: -1,
        //时间范围
        impdate: [],
        infoQuery: {
          pagecount: 10,
          currpage: 1,
          excelname: "",
          tableid: "XzReport,ProfitListDepartment2,ProfitListPartner2,ProfitListTeam2,ProfitListObject2,ProfitListUser2,RevexpDetails2",
          instname: "",
          impdatestart: "",
          impdateend: "",
          objname: "",
          strobjinstname: "",
          strusername: "",
          impdate: '',
          custname: '',
          reload: false
        },
        isReport: false,
        //定时器
        interval: null
      };
    },
    async created() {
      this.calHeight();
      this.custname = this.$route.query.custname;
      // this.infoQuery.tableid = this.$route.query.tableid;
      this.isReport = this.$route.query.isReport;
      if (this.isReport && this.isReport == 'true') {
        // this.infoQuery.custname = this.custname
        this.timeOut();
      } else {
        this.getExportRecord(this.infoQuery)
      }
    },
    methods: {
      calHeight() {
        this.tableHeight = Number(document.body.clientHeight);
        console.log('height', this.tableHeight)
      },
      //翻页
      handleCurrentChange(val) {
        // console.log(`当前页: ${val}`);
        this.currpage = `${val}`;
        this.infoQuery.currpage = val
        this.getExportRecord(this.infoQuery)
      },
      //搜索
      searchKeyWord() {
        this.infoQuery.currpage = 1
        this.getExportRecord(this.infoQuery)
      },
      //确保生成的一条数据是最新导出的
      timeOut() {
        this.listLoading = true
        setTimeout(() => {
          this.getlastexp()
        }, 3000)
      },
      //获取最新一条导出记录
      async getlastexp() {
        clearInterval(this.interval)
        this.listLoading = true
        xz.getLastExpData(this.custname).then(res => {
          this.tableData = []
          //  console.log('res',res)
          if (res && res != '没有记录！') {
            //  res.DtImpDate = res.DtImpDate.substring(0,10).replace(/-/, "/").replace(/-/, "/");
            this.tableData.push(res);
            if (res.StrOutPath) {
              var d = res.StrOutPath
              d = d.replace("\"", "").replace("\"", "")
              var path = this.tablePath + d
              this.$set(this.tableData[0], "path", path);
              this.clear()
            } else {
              this.interval = setInterval(this.getlastexp, 10000);
            }
            this.listLoading = false
          } else {
            this.tableData = []
            // this.listLoading = true
            this.interval = setInterval(this.getlastexp, 10000);
            // this.clear()
          }
        })
      },
      // 清除定时器的代码
      clear() {
        clearInterval(this.interval);
        this.interval = null
      },
      //导出记录历史
      getExportRecord(data) {
        // this.tableData = []
        this.listLoading = true
        xz.getExpRec(data).then(res => {
          console.log('导出记录历史', data, res)
          if (res.msg && res.msg.length > 0) {
            res.msg.forEach(l => {
              //  l.DtImpDate = l.DtImpDate.substring(0,10).replace(/-/, "/").replace(/-/, "/");
              if (l.StrTableId == 'ProfitListDepartment2') {}
              switch (true) {
                case l.StrTableId == 'ProfitListDepartment2':
                  this.$set(l, 'label', '利润汇总表（部门）');
                  break;
                case l.StrTableId == 'ProfitListPartner2':
                  this.$set(l, 'label', '利润汇总表（合伙人）');
                  break;
                case l.StrTableId == 'ProfitListTeam2':
                  this.$set(l, 'label', '利润汇总表（业务团队）');
                case l.StrTableId == 'ProfitListObject2':
                  this.$set(l, 'label', '利润汇总表（项目）');
                  break;
                case l.StrTableId == 'ProfitListUser2':
                  this.$set(l, 'label', '利润汇总表（业绩归属人）');
                  break;
                case l.StrTableId == 'XzReport':
                  this.$set(l, 'label', '雇员报表');
                  break;
                case l.StrTableId == 'RevexpDetails2':
                  this.$set(l, 'label', '利润明细表');
                  break;
                case (l.StrTableId.indexOf('ProfitListRecrEfficiency') != -1):
                  this.$set(l, 'label', '客服报表');
                  break;
                case (l.StrTableId.indexOf('ProfitListRecrChannel') != -1):
                  this.$set(l, 'label', '招聘渠道报表');
                  break;
                case (l.StrTableId.indexOf('ProfitListRecrCounselor') != -1):
                  this.$set(l, 'label', '招聘顾问效能报表');
                  break;
                case (l.StrTableId.indexOf('ProfitListRecrProjEffic') != -1):
                  this.$set(l, 'label', '招聘项目效能报表');
                  break;
              }
              if (l.StrOutPath) {
                var d = l.StrOutPath;
                d = d.replace("\"", "").replace("\"", "")
                var path = this.tablePath + d
                this.$set(l, "path", path);
              }
              this.listLoading = false
            });
            let r = res.msg.some(ele => ele.Strstatus == '0' && new Date().getTime() < new Date((new Date(ele.DtImpDate)).valueOf() + 360000).getTime())
            if (r) {
              this.interval = setTimeout(() => {
                this.getExportRecord(data)
              }, 10000);
            } else {
              clearTimeout(this.interval)
            }
            this.tableData = res.msg;
            this.totalnum = res.totalcount;
          } else {
            this.tableData = []
            this.totalnum = 0
          }
          this.listLoading = false
        })
      }
    },
    beforeDestroy() {
      // 在页面销毁后，清除计时器
      clearInterval(this.interval);
      this.interval = null
    }
  };
</script>



<style>
  .operationRecordTable .el-table td {
    padding: 5px 0;
  }

  .operationRecordTable .el-table th {
    padding: 10px 0;
  }

  .screenInput .el-input {
    width: 70%;
    margin-left: 5px;
  }

  .formScreenInput .el-input__inner {
    height: 32px;
    line-height: 32px;
    width: 180px;
    margin-top: 10px;
  }

  .formScreenInput .el-input__icon {
    margin-top: 10px;
    height: 32px;
    line-height: 32px;
  }
</style>